import { PostProperties } from "../types";
import image from "../img/lostGemStaceyPullen.jpg";

const post: PostProperties = {
  id: 39,
  title: "Stacey Pullen - Mighty, San Francisco (22.08.2009)",
  content: `Perfectly fitting for the summer, this week's lost gem comes from one of the key figures in the "second wave" of Detroit techno. Stacey Pullen is a DJ and producer who helped shape the genre. As one of the most respected artists from Detroit, he learned from the legendary Belleville Three - Derrick May, Juan Atkins, and Kevin Saunderson, who are known for their pioneering role in the genre.`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/stacey-pullen-mighty-san-francisco-22082009",
  category: "Lost Gem",
  translationsBg: {
    content: `Идеално подходящо за лятото, изгубеният скъпоценен камък тази седмица идва от една от ключовите фигури във „втората вълна“ на детройтското техно. Стейси Пълън е диджей и продуцент, който е помогнал за оформянето на жанра. Като един от най-уважаваните артисти от Детройт, той се е учил от легендарната тройка от Белвил - Дерик Мей, Хуан Аткинс и Кевин Сондерсън, които са известни с пионерската си роля в жанра.`,
  },
};

export default post;
